import { EProductStatus } from "@api/models/IProduct";
import SSAccountCard from "@core-components/accountCard/SSAccountCard";
import SSBoughtFooterCard from "@core-components/accountCard/components/SSBoughtFooterCard";
import SSHeaderCard from "@core-components/accountCard/components/SSHeaderCard";
import SSProductDetailLines from "@core-components/product/component/SSProductDetailLines";
import SSHeadline from "@core-components/title/SSHeadline";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Text } from "@mantine/core";
import getAvailableAccountIds from "@modules/order/hooks/getAvailableAccountIds.hook";
import { useValorantProductAsBasketAccount } from "@modules/order/hooks/useBasketItem.hook";
import type ValorantProduct from "../types/ValorantProduct";

interface IValorantAccountCardProps {
  product: ValorantProduct;
}

const ValorantAccountCard: React.FC<IValorantAccountCardProps> = ({
  product,
}) => {
  const { t } = useAppTranslation();
  const { getFirstAvailableId, isOutOfStock } = getAvailableAccountIds(
    product.accounts.map((account) => account.id),
  );

  return (
    <SSAccountCard
      header={
        <SSHeaderCard
          backgroundUrl={product.thumbnail}
          alt={t("alt", { name: t(`${product.i18nKey}.name`) })}
          isOutOfStock={isOutOfStock}
          variant="product"
        >
          <SSHeadline
            props={{
              stack: {
                align: "left",
              },
              title: { order: 3, className: "leading-3" },
            }}
            header={
              <Text className="text-left font-bold font-secret text-md text-primary-dark-text">
                {t(`${product.i18nKey}.status`)}
              </Text>
            }
          >
            <SSWhiteText className="font-secret-black text-lg">
              {t(`${product.i18nKey}.name`)}
            </SSWhiteText>
          </SSHeadline>
        </SSHeaderCard>
      }
    >
      <SSProductDetailLines
        {...product}
        i18nKey={product.i18nKey}
        status={EProductStatus.RANKED_READY}
        warantyText={t("warrantyText", { returnObjects: true }) as string[]}
      />
      <SSBoughtFooterCard
        isOutOfStock={isOutOfStock}
        isPopular={product.isPopular}
        account={useValorantProductAsBasketAccount(
          product,
          getFirstAvailableId(),
        )}
      />
    </SSAccountCard>
  );
};

export default ValorantAccountCard;
